<iframe #iframeElement [src]="sanitizeUrl" id="iframe-id" style="position:absolute;top:1px;left:1px;width:1px;height:1px;" (load)="iframeLoadedEvent()"></iframe>
